import { Box } from "@mui/material";
import Spinner, { SpinnerProps } from "./Spinner";

const Loading = (props: SpinnerProps) => {
  return (
    <Box display="flex" justifyContent="center">
      <Spinner {...props} />
    </Box>
  );
};

export default Loading;
